import { makeRequest } from "../../shared/utils";

export const getGeoData = async () => {
    const response = await makeRequest({
        method: "get",
        path: "/my-ip",
    });
    return response.data;
};
